import{createStyles as e}from"../../theme/utils/create-styles.js";import{spacing as o}from"../../theme/utils/spacing.js";var r=e({root:{},node:{marginTop:o(.5)},nodeHeader:{},leaf:{marginTop:o(.5)}});export{r as styles};
